<script lang="ts">import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { JanusSignonManagerToken, JanusSignonManager } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { f7, Link } from 'framework7-svelte';
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
$: profileStore = findSourceStore($sources, 'YinzCamSignonProfileSegment');
$: addressCity = ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.AddressCity) || '';
$: addressCountry = ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.AddressCountry) || '';
$: addressDivision1 = ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.AddressDivision1) || '';
$: addressPostal = ($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.AddressPostal) || '';
$: addressStreet =
    (($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.AddressStreet1) || '') +
        ' ' +
        (($profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.AddressStreet2) || '');
</script>

<div class="drop-win-bottom">
  {#if addressCity && addressCountry && addressDivision1 && addressPostal && addressStreet}
    <div class="info">
      We have all the information we need. We will ship your prize to you shortly.
    </div>
  {:else}
    <Link class="claim" href="/pages/en/Address">
      <img src="https://static.yinzcam.com/drops/nba/nyk/assets/claim_prize_button.svg" alt="claim" />
    </Link>
  {/if}
  <Link class="terms external" target="_blank" href="https://www.nhl.com/knicks/info/app">
    Knicks Drops Official Rules
  </Link>
</div>

<style type="text/scss">*,
*::after,
*::before {
  box-sizing: border-box;
}

.drop-win-bottom {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0 28px 0;
}

.drop-win-bottom .info {
  font-size: 14px;
  color: #eee;
  text-align: center;
  padding: 0 30px;
}

.drop-win-bottom :global(.claim) {
  display: block;
}

.drop-win-bottom :global(.claim img) {
  display: block;
  border-radius: 40px;
  width: 100%;
}

.drop-win-bottom :global(.terms) {
  margin: 12px 0 0 0;
  font-size: 14px;
  color: #61a6e4;
}</style>
